import { Injectable, inject } from '@angular/core';
import { API_URLS } from '../../constant/api-endpoint.constant';
import { BaseService, RestResponse } from '../base.service';
import { ApiKey } from './api-key.model';
import { LoginService } from '../../authentication/login/login.service';
import { QuerySearch } from '../query-search.model';
import { Observable } from 'rxjs';
import Utils from '../../utils/utils';
import {
  CriteriaCombined,
  CriterionCombinedType,
  CriteriaSimple,
} from '../../layout/search/search-filter/criterion/criteria/criteria.model';
import { Operators } from '../operators';

@Injectable({ providedIn: 'root' })
export class ApiKeyService extends BaseService<ApiKey> {
  override endpoint = API_URLS.API_KEY;
}

@Injectable({ providedIn: 'root' })
export class ApiKeyCurrentUserService extends ApiKeyService {
  private loginService = inject(LoginService);

  override search(query: QuerySearch): Observable<RestResponse<ApiKey>> {
    const newQuery = Utils.clone<QuerySearch>(query);
    const user = this.loginService.currentUser;
    const combined = newQuery.filter;
    newQuery.filter = new CriteriaCombined(CriterionCombinedType.AND, [
      new CriteriaSimple('user.login', Operators.EQUAL, user.login),
    ]);

    if (combined.criteria.length > 0) {
      newQuery.filter.criteria.push(combined);
    }
    return super.search(newQuery);
  }
}
